import { Workspace } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0142. ワークスペース解約
 * [DELETE] /workspaces/:identifier
 */
type Props = {
  identifier: string;
  name: string;
};
export const workspaceCancellation = (props: Props): Promise<Workspace> => {
  return axios.delete(`/api/workspaces/${props.identifier}`, { params: props });
};

export const useWorkspaceCancellation = () => {
  return useMutation({
    mutationFn: workspaceCancellation,
  });
};
